import { render, staticRenderFns } from "./MenuListComponent.vue?vue&type=template&id=6d01bbf3&scoped=true&"
import script from "./MenuListComponent.vue?vue&type=script&lang=js&"
export * from "./MenuListComponent.vue?vue&type=script&lang=js&"
import style0 from "./MenuListComponent.vue?vue&type=style&index=0&id=6d01bbf3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d01bbf3",
  null
  
)

export default component.exports